import { render } from "./DaftarKegiatan.vue?vue&type=template&id=cdee7822"
import script from "./DaftarKegiatan.vue?vue&type=script&lang=js"
export * from "./DaftarKegiatan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__